import React from "react";

const doesNothing = () => {};

const DeleteButton = ({ onClick = doesNothing }) => (
  <a className="action waves-effect borderless" onClick={onClick}>
    <i className="material-icons">delete</i>
  </a>
);

const Item = ({
  id,
  name = "",
  deleted,
  even = false,
  fixed = false,
  onDelete = doesNothing,
}) => {
  if (deleted === true) {
    return null;
  }
  const doDelete = () => {
    onDelete(id);
  };
  return (
    <React.Fragment>
      <tr className={`${even ? "even" : "odd"}`}>
        <td>{name}</td>
        <td className="text-center hides-content-to-operators">
          {fixed === true ? null : (
            <DeleteButton onClick={doDelete} />
          )}
        </td>
      </tr>
    </React.Fragment>
  );
};
const List = ({
  items = [],
  onDelete = doesNothing,
  onEdit = doesNothing,
  fieldLabel = "NAME"
}) => (
  <table className="table">
    <thead>
      <tr>
        <th className="uppercase">{fieldLabel}</th>
        <th className="text-center uppercase">ACTIONS</th>
      </tr>
    </thead>
    <tbody>
      {items
        .filter(({ deleted }) => deleted !== true)
        .map(({ __id, ...client }, index) => (
          <Item
            id={__id}
            key={__id}
            {...client}
            even={(index + 1) % 2 === 0}
            onDelete={() => onDelete(__id)}
            onEdit={() => onEdit(__id)}
          />
        ))}
    </tbody>
  </table>
);
export default List;
